import React, { useState } from 'react';

import { BudgetRange } from '@common-types';
import FilterSkeleton from '../dashboard-aside-filter-skeleton/component';
import { WalletSearchSlider } from '../../common';

import './style.scss';
import { ILoginState } from '@share/store/slices';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { FormattedMessage, useIntl } from 'react-intl';

interface IMapStateToProps {
  loginStore: ILoginState;
}
const DashoardAside: React.FC<any> = ({
  payload,
  fetchHotels,
  setSearchHotels,
  setLoading,
  setPageNumber,
  setPayload,
  counters,
  loading,

  isInView,
  walletHasSliderOnSearch,
  selectedClientCash,
  onSelectClientCash,
}) => {
  const login = useSelector((state: IMapStateToProps) => state.loginStore);
  const account = login?.account;
  const buttonColor = account?.buttonColor;
  const [sortBy, setSortBy] = useState('BiggestSavingsPercentage');
  const [selectedRange, setSelectedRange] = useState<{ from?: number; to?: number } | null>(null);
  const [selectedType, setSelectedType] = useState<string | null>(null);
  const [selectedAmenities, setSelectedAmenities] = useState<string[]>([]);
  const [showAllAmenity, setShowAllAmenity] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const [customerRating, setCustomerRating] = useState<any[]>([]);
  const [propertyNames, setPropertyNames]= useState<string>('')

  const handleAccommodationTypeChange = (key: string, isChecked: boolean) => {
    if (isChecked) {
      setSelectedType(key); // Set the selected type
      applyFilter('accommodationType', [key]);
    } else {
      setSelectedType(null); // Uncheck if the same type is unchecked
      applyFilter('accommodationType', []);
    }
  };

  const toggleShowAll = () => {
    setShowAll(!showAll);
  };
  const toggleShowAllAmenity = () => {
    setShowAllAmenity(!showAllAmenity);
  };

  const handlePriceChange = (range: { from?: number; to?: number }, isChecked: boolean) => {
    if (isChecked) {
      setSelectedRange(range);
      applyFilter('budgetRanges', [range]);
    } else {
      setSelectedRange(null);
      applyFilter('budgetRanges', []);
    }
  };

  const handleSortChange = (e: any) => {
    setSortBy(e.target.value);
    setLoading(true);
    setPayload((prev: any) => {
      return {
        ...prev,
        pageNumber: 1,
        sortBy: e.target.value,
      };
    });
    fetchHotels(
      {
        ...payload,
        pageNumber: 1,
        filter: {
          ...payload.filter,
        },
        sortBy: e.target.value,
      },
      () => {
        setPageNumber(1);
      },
    );
  };

  const handleAmenitiesChange = (key: string, isChecked: boolean) => {
    if (isChecked) {
      setSelectedAmenities([...selectedAmenities, key]); // Add to selected amenities
      applyFilter('amenities', [...selectedAmenities, key]);
    } else {
      setSelectedAmenities(selectedAmenities.filter((amenity) => amenity !== key));
      const filteredItems = selectedAmenities.filter((item) => item !== key);
      applyFilter('amenities', filteredItems);
    }
  };

  const handleStarRatingChange = (type: any, isChecked: boolean) => {
    if (isChecked) {
      setCustomerRating((prevTypes: any[]) => [...prevTypes, type]);
      applyFilter('starRatings', [...customerRating, type]);
    } else {
      const filteredItems = customerRating.filter((item) => item !== type);
      setCustomerRating(filteredItems);
      applyFilter('starRatings', filteredItems);
    }
  };

  const applyFilter = (type: any, value: any) => {
    setLoading(true);
    setSearchHotels([]);
    setPayload((prev: any) => {
      return {
        ...prev,
        pageNumber: 1,
        filter: {
          ...payload.filter,
          [type]: value,
        },
        sortBy,
      };
    });
    fetchHotels(
      {
        ...payload,
        pageNumber: 1,
        filter: {
          ...payload.filter,
          [type]: value,
        },
        sortBy,
      },
      () => {
        setPageNumber(1);
      },
    );
  };

  const resetFilters = (event: any) => {
    event.preventDefault();
    setLoading(true);
    setSearchHotels([]);
    setSortBy('BiggestSavings');
    setPayload((prev: any) => {
      return {
        ...prev,
        pageNumber: 1,
        filter: {
          distanceInMiles: 10,
          exactSearch: true,
        },
        sortBy: 'BiggestSavings',
      };
    });
    fetchHotels(
      {
        ...payload,
        pageNumber: 1,
        filter: {
          distanceInMiles: 10,
          exactSearch: true,
        },
        sortBy: 'BiggestSavings',
      },
      () => {
        setPageNumber(1);
      },
    );
    setCustomerRating([]);
  };

  const visibleItems = showAll ? counters?.propertyTypes : counters?.propertyTypes?.slice(0, 4);
  const visibleAmenityItems = showAllAmenity
    ? counters?.amenities
    : counters?.amenities?.slice(0, 4);
    const intl = useIntl();
  return (
    <>
      {!loading ? (
        <div className="col-xl-4 col-xxl-3">
          <div
            className="dashboard offcanvas-xl offcanvas-end"
            id="offcanvasSidebar"
            aria-labelledby="offcanvasSidebarLabel"
          >
            <div className="offcanvas-header">
              <h5 className="offcanvas-title" id="offcanvasSidebarLabel">
                Advance Filters
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="offcanvas"
                data-bs-target="#offcanvasSidebar"
                aria-label="Close"
              ></button>
            </div>

            <div className="offcanvas-body flex-column p-3 p-xl-0">
              <div className="rounded-3 shadow">
                {/*
                <div className="mt-3 d-flex justify-content-end p-4 reset-filters">
                  <span onClick={resetFilters} className="btn btn-link p-0 mb-0">Clear filters</span>
                </div> */}

                <div className="card card-body rounded-0 rounded-top p-4 pt-2">
                  <h6 className="mb-2">{intl.formatMessage({ id: 'sort.by' })}</h6>
                  <select
                    className="form-select js-choice"
                    value={sortBy}
                    onChange={handleSortChange}
                  >
                    <option value="BiggestSavings">
                      {intl.formatMessage({ id: 'sort.bestValue' })}
                    </option>
                    <option value="DistanceAsc">
                      {intl.formatMessage({ id: 'sort.distance' })}
                    </option>
                    <option value="PriceAsc">
                      {intl.formatMessage({ id: 'sort.priceLowToHigh' })}
                    </option>
                    <option value="PriceDesc">
                      {intl.formatMessage({ id: 'sort.priceHighToLow' })}
                    </option>
                    <option value="GuestRating">
                      {intl.formatMessage({ id: 'sort.guestRating' })}
                    </option>
                    <option value="SavedProperties">
                      {intl.formatMessage({ id: 'sort.savedProperties' })}
                    </option>
                  </select>
                </div>

                <hr className="my-0" />

                <div className="card card-body rounded-0 p-4">
                  <h6 className="mb-2">{intl.formatMessage({ id: 'accommodation.type' })}</h6>
                  <div className="col-12">
                  {visibleItems?.map((type: any, index: number) => {
                    const keyId = type.key
                      .toLowerCase()
                      .replace(/\s+/g, '')   
                      .replace(/[^a-z]/gi, ''); 
                    const label = intl.formatMessage(
                      { id: `accommodationType.${keyId}` },
                      {},
                      type.key 
                    );

                    return (
                      <div className="form-check" key={index}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={selectedType === type.key}
                          onChange={(e) => handleAccommodationTypeChange(type.key, e.target.checked)}
                          id={`accommodationType${index}`}
                        />
                        <label className="form-check-label" htmlFor={`accommodationType${index}`}>
                          {label} ({type.count})
                        </label>
                      </div>
                    );
                  })}


                    {counters?.propertyTypes && counters.propertyTypes.length > 4 && (
                      <a
                        className={`p-0 mb-0 mt-2 d-flex align-items-center collapsed ${buttonColor ? '': 'btn-more '}`}
                        data-bs-toggle="collapse"
                        href="#hotelType"
                        role="button"
                        aria-expanded="false"
                        aria-controls="hotelType"
                        onClick={toggleShowAll}
                        style={{ color: `${buttonColor}`  }}
                      >
                        {intl.formatMessage({ id: 'see' })} <span className="see-more ms-1 123">{showAll ? (intl.formatMessage({ id: 'less' })) : (intl.formatMessage({ id: 'more' }))}</span>
                        <i
                          className={`fa-solid fa-angle-down ms-2 ${showAll ? 'rotate-180' : ''}`}
                        ></i>
                      </a>
                    )}
                  </div>
                </div>

                <hr className="my-0" />

                <div className="card card-body rounded-0 p-4">
                  <h6 className="mb-2">{intl.formatMessage({ id: 'property.name' })}</h6>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Filter by name"
                    value={propertyNames}
                    onChange={(e) => {
                      applyFilter('propertyName', e.target.value),
                        setPropertyNames(e.target.value);
                    }}
                  />
                </div>

                <hr className="my-0" />

                <div className="card card-body rounded-0 p-4">
                  <h6 className="mb-2">{intl.formatMessage({ id: 'price.range' })}</h6>
                  <div className="col-12">
                    {counters?.budgetRanges?.map((range: BudgetRange, index: number) => (
                      <div className="form-check" key={index}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={
                            selectedRange?.from === range.key.from &&
                            selectedRange?.to === range.key.to
                          }
                          onChange={(e) => handlePriceChange(range.key, e.target.checked)}
                          id={`budgetRange${index}`}
                        />
                        <label className="form-check-label" htmlFor={`budgetRange${index}`}>
                          {range.key.from === undefined && `Up to $${range.key.to}`}
                          {range.key.to === undefined && `$${range.key.from} ${(intl.formatMessage({ id: 'price.filter.above' }))}`}
                          {range.key.from !== undefined &&
                            range.key.to !== undefined &&
                            `$${range.key.from} - $${range.key.to}`}
                        </label>
                        <span className="text-muted"> ({range.count})</span>
                      </div>
                    ))}
                  </div>
                </div>

                <hr className="my-0" />

                <div className="card card-body rounded-0 p-4">
                  <h6 className="mb-2">{intl.formatMessage({ id: 'filter.amenities' })}</h6>
                  <div className="col-12">
                    {visibleAmenityItems?.map((amenity: any, index: any) => (
                      <div className="form-check" key={index}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={selectedAmenities.includes(amenity.key)}
                          onChange={(e) => handleAmenitiesChange(amenity.key, e.target.checked)}
                          id={`amenity${index}`}
                        />
                        <label className="form-check-label" htmlFor={`amenity${index}`}>
                          {amenity.key} ({amenity.count})
                        </label>
                      </div>
                    ))}

                    {counters?.amenities && counters.amenities.length > 4 && (
                      <a
                        className="p-0 mb-0 mt-2 btn-more d-flex align-items-center collapsed"
                        data-bs-toggle="collapse"
                        href="#amenities"
                        role="button"
                        aria-expanded="false"
                        aria-controls="amenities"
                        onClick={toggleShowAllAmenity}
                        style={{ color: `${buttonColor}`  }}
                      >
                    {intl.formatMessage({ id: 'see' })} <span className="see-more ms-1">{showAllAmenity ? (intl.formatMessage({ id: 'less' })) : (intl.formatMessage({ id: 'more' }))}</span>
                        <i
                      className={`fa-solid fa-angle-down ms-2 ${showAllAmenity ? 'rotate-180' : ''}`}
                        ></i>
                      </a>
                    )}
                  </div>
                </div>

                <hr className="my-0" />

                <div className="card card-body rounded-0 p-4">
                  <h6 className="mb-2">{intl.formatMessage({ id: 'star.rating' })}</h6>
                  <ul className="list-inline mb-0 g-3">
                    <li className="list-inline-item mb-0">
                      <input
                        className="btn-check border border-black"
                        type="checkbox"
                        checked={customerRating.includes(3)}
                        id="rating-3"
                        onChange={(e) => handleStarRatingChange(3, e.target.checked)}
                      />

                      <label
                        htmlFor="rating-3"
                        className="btn btn-sm btn-light btn-primary-soft-check"
                      >
                        3+ <i className="bi bi-star-fill text-warning"></i>
                      </label>
                    </li>

                    <li className="list-inline-item mb-0">
                      <input
                        className="btn-check border border-black"
                        type="checkbox"
                        checked={customerRating.includes(4)}
                        id="rating-4"
                        onChange={(e) => handleStarRatingChange(4, e.target.checked)}
                      />

                      <label
                        htmlFor="rating-4"
                        className="btn btn-sm btn-light btn-primary-soft-check"
                      >
                        4+ <i className="bi bi-star-fill text-warning"></i>
                      </label>
                    </li>
                    <li className="list-inline-item mb-0">
                      <input
                        id="rating-5"
                        className="btn-check border border-black"
                        type="checkbox"
                        checked={customerRating.includes(5)}
                        onChange={(e) => handleStarRatingChange(5, e.target.checked)}
                      />

                      <label
                        htmlFor="rating-5"
                        className="btn btn-sm btn-light btn-primary-soft-check"
                      >
                        5.0 <i className="bi bi-star-fill text-warning"></i>
                      </label>
                    </li>
                  </ul>
                </div>
                <hr className="my-0" />
              </div>
              <div
                className="d-flex justify-content-center reset-filters mt-xl-4"
                style={{ '--dynamic-color': buttonColor || undefined } as React.CSSProperties} 
              >
                <span onClick={resetFilters} className="mb-0 clear-filters">
                  {intl.formatMessage({ id: 'filter.clear.filters' })}
                </span>
              </div>
            </div>
          </div>

          {(walletHasSliderOnSearch) && (
              <div className="card sticky-top shadow p-2 mb-4 result-wrapper__top-section top-0 z-index-1" style={{ marginTop: '20px' }}>
                <WalletSearchSlider
                  display={true}
                  selectedClientCash={selectedClientCash}
                  onSelectClientCash={onSelectClientCash}
                  oneRow
                />
              </div>)}            
        </div>
      ) : (
        <>
          {[...Array(1)].map((_, index) => (
            <FilterSkeleton key={`skeleton-2-${index}`} />
          ))}
        </>
      )}
    </>
  );
};

export default DashoardAside;
